export default "__VITE_ASSET__4c067df1__"